import { action } from '@ember/object';
import Component from '@glimmer/component';

import { OrderDirection } from 'webapp/enums/enums';

import FormRadiobuttonGroupComponent from 'webapp/components/form/radiobutton-group';

import type Block from 'webapp/models-custom/block';

interface Args {
	blockM: Block;
}

export default class BlockSettingsSortOrderComponent extends Component<Args> {
	options: { value: OrderDirection; label: string; icon: IconName }[] = [
		{
			value: OrderDirection.ASC,
			label: 'Ascending',
			icon: 'ArrowUp',
		},
		{
			value: OrderDirection.DESC,
			label: 'Descending',
			icon: 'ArrowDown',
		},
	];

	get block(): Block {
		return this.args.blockM;
	}

	get blockSetup() {
		return this.block.blockSetup;
	}

	get selected(): OrderDirection {
		return this.block.sortOrder || OrderDirection.DESC;
	}

	@action
	changeSelected(sortOrder: AnySimpleValue): void {
		this.block.sortOrder = sortOrder as OrderDirection;
		this.blockSetup.saveBlock();
		this.blockSetup.trackBlockPropertySettingsChangeEvent({ sort_order: sortOrder });
	}
	<template>
		<div class="row sort-order">
			<label>Sort order</label>
			<FormRadiobuttonGroupComponent
				class="radiobutton-switcher"
				@name="sortOrder"
				@selected={{this.selected}}
				@options={{this.options}}
				@onChange={{this.changeSelected}}
				@theme="dark-blue"
			/>
		</div>
	</template>
}
